module.exports = __webpack_public_path__ + "media/images/new_home/eo_logo_forest-be45ca67b412b7de9ad2660182a28c5b.png";